import { c as _c } from "react/compiler-runtime";
import { getWellingtonRouteBadgeRenderSpec } from "@/lib/routeBadgeSvg";
export default function RouteBadge(t0) {
  const $ = _c(27);
  const {
    className,
    route_color,
    routeLabel,
    route_short_name,
    route_type,
    service_id,
    style,
    includeDefaultClassName: t1
  } = t0;
  const includeDefaultClassName = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== routeLabel || $[1] !== route_color || $[2] !== route_short_name || $[3] !== route_type || $[4] !== service_id) {
    t2 = getWellingtonRouteBadgeRenderSpec({
      routeColor: route_color,
      routeLabel,
      routeType: route_type,
      route_short_name,
      service_id
    });
    $[0] = routeLabel;
    $[1] = route_color;
    $[2] = route_short_name;
    $[3] = route_type;
    $[4] = service_id;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    label,
    type,
    fillColor,
    strokeColor,
    textColor,
    letterSpacing,
    fontSize,
    textY,
    textX,
    fontWeight
  } = t2;
  const t3 = includeDefaultClassName ? `max-h-full max-w-full select-none ${className ? className : ""}` : className;
  const t4 = strokeColor ? 48 : 50;
  const t5 = strokeColor ? 4 : null;
  let t6;
  if ($[6] !== fillColor || $[7] !== strokeColor || $[8] !== t4 || $[9] !== t5) {
    t6 = <circle cx="50" cy="50" r={t4} fill={fillColor} stroke={strokeColor} strokeWidth={t5} />;
    $[6] = fillColor;
    $[7] = strokeColor;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== type) {
    t7 = type === "night" && <><defs><mask id="insetMask"><circle cx="32" cy="50" r="50" fill="white" /></mask></defs><circle cx="50" cy="50" r="50" fill="#101827DD" mask="url(#insetMask)" /></>;
    $[11] = type;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== fontSize || $[14] !== fontWeight || $[15] !== label || $[16] !== letterSpacing || $[17] !== textColor || $[18] !== textX || $[19] !== textY) {
    t8 = <text fill={textColor} x={textX} y={textY} textAnchor="middle" fontSize={fontSize} fontWeight={fontWeight} letterSpacing={letterSpacing} fontFamily="Bus, sans-serif">{label}</text>;
    $[13] = fontSize;
    $[14] = fontWeight;
    $[15] = label;
    $[16] = letterSpacing;
    $[17] = textColor;
    $[18] = textX;
    $[19] = textY;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== style || $[22] !== t3 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t9 = <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={t3} style={style}>{t6}{t7}{t8}</svg>;
    $[21] = style;
    $[22] = t3;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}